<template>
  <NuxtTime v-bind="options" :datetime :locale />
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import type { TheTimeProps } from './types'

const currentLocale = useI18nLocale()

const props = defineProps<TheTimeProps>()

const locale = computed(() => props.locale ?? currentLocale)
const datetime = computed(() => props.datetime ?? new Date())
</script>
